
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.addEventListener('frame-ready', init)

function init() {
    let lists = Array.from(document.querySelectorAll('.cookery-books--list'))

    if (lists) {

        lists.forEach(list => {

            let books = Array.from(list.querySelectorAll('.cookery-book'))

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: list,
                    start: 'top center+=10%',
                    end: 'bottom bottom',
                    //markers: true,
                    toggleActions: 'play none none reverse',
                }
            })

            books.forEach( book => {
                gsap.set(book, { translateX: '-30px', opacity: 0 })
            })

            books.reverse().forEach((book, i) => {
                let offset = i > 0 ? .15 : 0
                tl.to(book, { translateX: '0', opacity: 1, duration: .2 }, `-=${offset}`)
            })
        })

    }
}